import { render, staticRenderFns } from "./Cargos_perfil.vue?vue&type=template&id=9fc324b4&scoped=true"
import script from "./Cargos_perfil.vue?vue&type=script&lang=js"
export * from "./Cargos_perfil.vue?vue&type=script&lang=js"
import style0 from "./Cargos_perfil.vue?vue&type=style&index=0&id=9fc324b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fc324b4",
  null
  
)

export default component.exports